module.exports = __webpack_public_path__ + "media/2800_CT_2022_Intro.0e8f47d9.mp4";